<template>
  <el-row class="full-height" :gutter="10" style="margin: 0px; padding: 10px 4px">
    <el-col class="full-height" :span="8">
      <el-container class="full-height">
        <el-header height="auto" class="no-padding">
          <el-form size="small" label-position="top">
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="Nome">
                  <el-input v-model="imobiliariaPesquisa.nome" @keyup.enter.native="pressEnterPesquisaNome" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="Status">
                  <el-select v-model="imobiliariaPesquisa.statusContratoSAC">
                    <el-option label="Todos" :value="undefined" />
                    <el-option label="Ativo" value="ATIVO" />
                    <el-option label="Inativo" value="INATIVO" />
                    <el-option label="Inadimplente" value="INADIMPLENTE" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col>
                <el-button @click="clickNovo" size="small" type="success">Novo</el-button>
                <el-button @click="clickPesquisar" size="small" type="primary">Pesquisar</el-button>
                <el-button @click="clickLimpar" size="small" type="warning">Limpar</el-button>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col>
                <span style="font-size: 14px; color: #777">{{ textoQtdImobiliarias }}</span>
              </el-col>
            </el-row>
          </el-form>
        </el-header>

        <el-main style="height: 100%; padding: 0px; margin-top: 10px">
          <el-table
            @row-dblclick="clickImobiliaria"
            :data="imobiliarias"
            empty-text="Nenhuma Imobiliária"
            height="100%"
            highlight-current-row
            stripe
          >
            <el-table-column label="ID" width="60" prop="id" />
            <el-table-column label="Nome" prop="nome" show-overflow-tooltip />
          </el-table>
        </el-main>
      </el-container>
    </el-col>
    <el-col :span="16" class="full-height">
      <el-container class="full-height">
        <el-header height="40px" style="padding: 10px 0px">
          <span style="color: #777; font-weight: bold">{{ textoImobiliariaSelecionada }}</span>
        </el-header>
        <el-main class="full-height" style="background: #FFF; padding: 10px 0px 0px 0px">
          <div class="tab-container">
            <el-tabs @tab-click="clickTab" v-model="tabSelecionada" style="padding: 0px 10px">
              <el-tab-pane label="Detalhes" name="detalhes" class="full-height scrollable">
                <el-form size="small" ref="form" :rules="formRules" hide-required-asterisk :show-message="false" :model="imobiliaria">
                  <div style="color: #777; font-weight: bold; font-size: 15px">
                    <i class="el-icon-document" />
                    Informações Básicas
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="8">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.bloqueada">Bloqueada</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.exibirNoImoveis">Exibir no Imoveis86</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.locacaoPropria">Locação Própria</el-checkbox>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="18">
                        <el-form-item label="Nome" prop="nome">
                          <el-input v-model="imobiliaria.nome" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="Creci">
                          <el-input v-model="imobiliaria.creci" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="18">
                        <el-form-item label="Razão Social" prop="razaoSocial">
                          <el-input v-model="imobiliaria.razaoSocial" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="CNPJ" prop="cnpj">
                          <el-input v-model="imobiliaria.cnpj" v-mask="'##.###.###/####-##'" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="9">
                        <el-form-item label="Nome do Representante" prop="nomeRepresentante">
                          <el-input v-model="imobiliaria.nomeRepresentante" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="9">
                        <el-form-item label="Email do Representante" prop="emailRepresentante">
                          <el-input v-model="imobiliaria.emailRepresentante" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="CPF do Representante" prop="cpfRepresentante">
                          <el-input v-model="imobiliaria.cpfRepresentante" v-mask="'###.###.###-##'" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-phone" />
                    Contato
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Telefone" prop="telefone">
                          <el-input v-model="imobiliaria.telefone" v-mask="['(##) ####-####', '(##) #####-####']" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Celular">
                          <el-input v-model="imobiliaria.celular" v-mask="['(##) ####-####', '(##) #####-####']" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="WhatsApp Locação">
                          <el-input v-model="imobiliaria.whatsapp" v-mask="['(##) ####-####', '(##) #####-####']" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="WhatsApp Venda">
                          <el-input v-model="imobiliaria.whatsappVenda" v-mask="['(##) ####-####', '(##) #####-####']" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="E-mail" prop="email">
                          <el-input v-model="imobiliaria.email" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="E-mail Financeiro" prop="emailFinanceiro">
                          <el-input v-model="imobiliaria.emailFinanceiro" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="E-mail para avisos dos portais">
                          <el-input v-model="imobiliaria.emailPortais" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Site">
                          <el-input v-model="imobiliaria.site" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-location" />
                    Endereço
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="20">
                        <el-form-item label="Endereço" prop="endereco">
                          <el-input v-model="imobiliaria.endereco" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item label="Número">
                          <el-input v-model="imobiliaria.numeroEndereco" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="20">
                        <el-form-item label="Complemento">
                          <el-input v-model="imobiliaria.complemento" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item label="CEP">
                          <el-input v-model="imobiliaria.cep" v-mask="'#####-###'" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="4">
                        <el-form-item label="UF" prop="estado">
                          <el-select @change="changeEstado" v-model="imobiliaria.estado" value-key="id" placeholder="" filterable default-first-option style="width: 100%">
                            <el-option v-for="estado in estados" :key="estado.id" :label="estado.sigla" :value="estado" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="10">
                        <el-form-item label="Cidade" prop="cidade">
                          <el-select
                            @change="changeCidade"
                            v-model="imobiliaria.cidade"
                            :remote-method="pesquisarCidades"
                            :loading="isLoadingCidades"
                            value-key="id"
                            placeholder=""
                            loading-text="Carregando cidades"
                            no-data-text="Nenhuma cidade encontrada"
                            filterable
                            remote
                            default-first-option
                            style="width: 100%">
                              <el-option
                                v-for="cidade in cidades"
                                :key="cidade.id"
                                :label="cidade.nome"
                                :value="cidade">
                              </el-option>
                            </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="10">
                        <el-form-item label="Bairro" prop="bairro">
                          <el-select
                            v-model="imobiliaria.bairro"
                            :remote-method="pesquisarBairros"
                            :loading="isLoadingBairros"
                            value-key="id"
                            placeholder=""
                            loading-text="Carregando bairros"
                            no-data-text="Nenhum bairro encontrado"
                            filterable
                            remote
                            default-first-option
                            style="width: 100%">
                              <el-option v-for="bairro in bairros" :key="bairro.id" :label="bairro.nome" :value="bairro"/>
                            </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="20">
                      <el-col :span="10">
                        <el-form-item label="Latitude" prop="latitude">
                          <el-input v-model="imobiliaria.latitude"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="10">
                        <el-form-item label="Longitude" prop="longitude">
                          <el-input v-model="imobiliaria.longitude"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-info" />
                    Numerações
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="8">
                        <el-form-item label="Imóveis">
                          <el-input v-model="imobiliaria.numeracao.idImovelCorrente"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Clientes">
                          <el-input v-model="imobiliaria.numeracao.idClienteCorrente"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Recibos">
                          <el-input v-model="imobiliaria.numeracao.numeroReciboCorrente"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-pie-chart" />
                    Imóveis Cadastrados
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="3">
                        <el-form-item label="Vendidos">
                          <el-input v-model="imobiliaria.imoveisVendidos" readonly />
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item label="Locados">
                          <el-input v-model="imobiliaria.imoveisLocados" readonly />
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item label="Desocupação">
                          <el-input v-model="imobiliaria.imoveisEmDesocupacao" readonly />
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item label="Reservados">
                          <el-input v-model="imobiliaria.imoveisReservados" readonly />
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item label="Disponíveis">
                          <el-input v-model="imobiliaria.imoveisDisponiveis" readonly />
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item label="Indisponíveis">
                          <el-input v-model="imobiliaria.imoveisIndisponiveis" readonly />
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item label="Arquivados">
                          <el-input v-model="imobiliaria.imoveisArquivados" readonly />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-money" />
                    Financeiro
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="8">
                        <el-form-item label="Valor do E-mail e Site">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.valorEmailSite" v-bind="moneyFormat" class="el-input__inner"/>
                          </div>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Tabela de Preço">
                          <el-input v-model="imobiliaria.tabelaPreco"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Dia de Vencimento da Fatura">
                          <el-input v-model="imobiliaria.diaVencimentoFatura" v-mask="'##'" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="8">
                        <el-form-item label="Desconto na Mensalidade">
                          <money v-model="imobiliaria.percentualDescontoMensalidade" v-bind="percentFormat" class="el-input__inner"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Status do Contrato">
                          <el-select v-model="imobiliaria.statusContratoSAC" style="width: 100%">
                            <el-option label="Ativo" value="ATIVO" />
                            <el-option label="Inativo" value="INATIVO" />
                            <el-option label="Inadimplente" value="INADIMPLENTE" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-s-marketing" />
                    Módulos Contratados
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="3">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.moduloAluguel">Aluguel</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.moduloVenda">Venda</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.moduloFinanceiro">Financeiro</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.contasEmail">Email</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.appVistoria">Aplicativo de Vistoria</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="3" style="margin-left: 87px">
                        <el-form-item>
                          <el-checkbox v-model="isSitePublicado" :disabled="true">Site</el-checkbox>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-s-marketing" />
                    E-mails automáticos
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="16">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.avisoVencimentoProximo">Aviso de Vencimento Próximo do Aluguel</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Horário de Execução">
                          <el-select v-model="imobiliaria.horaExecucaoEmailBoleto">
                            <el-option v-for="hora in horaDoDia" :key="hora.data" :label="hora.label" :value="hora.data" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="16">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.avisoAposVencimento">Aviso Após o Vencimento do Aluguel</el-checkbox>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="16">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.emailAcompanhamentoImovel">Acompanhamento do Imóvel</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Horário de Execução">
                          <el-select v-model="imobiliaria.horaExecucaoEmailAcompanhamentoImovel">
                            <el-option v-for="hora in horaDoDia" :key="hora.data" :label="hora.label" :value="hora.data" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="16">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.emailAniversario">Aniversário</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Horário de Execução">
                          <el-select v-model="imobiliaria.horaExecucaoEmailAniversario">
                            <el-option v-for="hora in horaDoDia" :key="hora.data" :label="hora.label" :value="hora.data" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <!---->

                    <el-row :gutter="10">
                      <el-col :span="16">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.emailAluguelPago">Aviso email Aluguel pago</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Horário de Execução">
                          <el-select v-model="imobiliaria.horaExecucaoEmailAluguelPago">
                            <el-option v-for="hora in horaDoDia" :key="hora.data" :label="hora.label" :value="hora.data" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="16">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.emailRepassePago">Aviso email Repasse pago</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Horário de Execução">
                          <el-select v-model="imobiliaria.horaExecucaoEmailRepassePago">
                            <el-option v-for="hora in horaDoDia" :key="hora.data" :label="hora.label" :value="hora.data" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="16">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.enviarAvisoIptu">Email aviso de IPTU</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Horário de Execução">
                          <el-select v-model="imobiliaria.horaExecucaoEmailAvisoIptu">
                            <el-option v-for="hora in horaDoDia" :key="hora.data" :label="hora.label" :value="hora.data" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="10">
                        <el-form-item label="Horário de Execução aviso Reajuste e Renovação">
                          <el-select v-model="imobiliaria.horaExecucaoEmailReajusteRenovacao">
                            <el-option v-for="hora in horaDoDia" :key="hora.data" :label="hora.label" :value="hora.data" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="10">
                        <el-form-item label="Horário de Execução aviso Recibo não registrado">
                          <el-select v-model="imobiliaria.horaExecucaoEmailAvisoRecibosNaoRegistrados">
                            <el-option v-for="hora in horaDoDia" :key="hora.data" :label="hora.label" :value="hora.data" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                  </div>

                </el-form>
              </el-tab-pane>

              <el-tab-pane label="Proposta" name="proposta" class="full-height scrollable">
                <el-form size="small" label-position="top">
                  <div style="color: #777; font-weight: bold; font-size: 15px">
                    <i class="el-icon-document" />
                    Proposta Comercial
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="6">
                        <el-form-item label="Data">
                          <el-input v-model="imobiliaria.propostaComercial.data" v-mask="'####-##-##'" placeholder="1999-09-09"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="18">
                        <el-form-item label="Vendedor">
                          <el-input v-model="imobiliaria.propostaComercial.vendedor"/>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Plano até 100 imóveis">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano100" v-bind="moneyFormat" class="el-input__inner"/>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Plano até 250 imóveis">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano250" v-bind="moneyFormat" class="el-input__inner"/>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Plano até 500 imóveis">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano500" v-bind="moneyFormat" class="el-input__inner"/>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Plano até 1000 imóveis">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano1000" v-bind="moneyFormat" class="el-input__inner"/>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Plano até 2000 imóveis">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano2000" v-bind="moneyFormat" class="el-input__inner"/>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Plano até 3000 imóveis">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano3000" v-bind="moneyFormat" class="el-input__inner"/>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Acima de 3000 imóveis - incremento a cada 250 imóveis">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano3000mais" v-bind="moneyFormat" class="el-input__inner"/>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Implantação, treinamento e acompanhamento presencial A partir do plano 500">
                          <el-input value="50% do plano/dia"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Implantação e treinamento remoto (2 horas)">
                          <el-input value="Incluso"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Implantação e treinamento presencial (3 horas) A partir do plano 500">
                          <el-input value="50% do plano"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="(Opcional) Importação SICADI/Sistemas Terceiros">
                          <el-input value="1 mensalidade do plano"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="(Opcional) Visita técnica - 2h">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.visitaTecnica" v-bind="moneyFormat" class="el-input__inner"/>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="(Opcional) Site">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.site" v-bind="moneyFormat" class="el-input__inner"/>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="(Opcional) Site + 10 contas de e-mail">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.siteEmail" v-bind="moneyFormat" class="el-input__inner"/>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-form>
              </el-tab-pane>

              <el-tab-pane v-if="isVisibleTabUsuarios" label="Usuários" class="full-height scrollable">
                <el-form label-position="top" size="small">
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="Nome">
                        <el-input v-model="usuarioPesquisa.nome" />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" style="margin-top: 8px">
                      <el-form-item>
                        <el-button @click="clickAdicionarUsuario" size="small" type="success" style="text-align: right; margin-top: 10px">Adicionar</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-table :data="usuarios" height="500" border style="padding: 10px; margin-top: 10px" highlight-current-row @row-dblclick="doubleClickUsuario"  empty-text="Nenhum Usuário Encontrado">
                    <el-table-column label="Nome" prop="nome" />
                    <el-table-column label="Último Acesso" prop="ultimoAcesso" :formatter="formatarUltimoAcesso" width="250" />
                    <el-table-column label="Suporte" width="100">
                      <template slot-scope="scope">
                        <el-checkbox @change="gravarUsuarioComoSuporte(scope.row)" v-model="scope.row.suporte"/>
                      </template>
                    </el-table-column>
                  </el-table>

                </el-form>
              </el-tab-pane>

              <el-tab-pane v-if="isVisibleTabParametrosSite" label="Parâmetros do Site" name="parametrosSite" class="full-height scrollable">
                <el-form :model="parametrosSite" :rules="formParametrosSite" ref="formSite" hide-required-asterisk :show-message="false" size="small" label-position="top">
                  <div style="color: #777; font-weight: bold; font-size: 15px">
                    <i class="el-icon-document" />
                    Configurações Básicas
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Modelo do Site">
                          <el-select v-model="parametrosSite.modelo">
                            <el-option value="MODELO_1" label="Modelo 1" />
                            <!--<el-option value="MODELO_2" label="Modelo 2" /> -->
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <span style="font-size: 15px">{{ 'Status site: ' + `${this.imobiliaria.parametrosSite.status == 'PUBLICAR' || this.imobiliaria.parametrosSite.status =='PUBLICADO' ? 'Ativo' : 
                          this.imobiliaria.parametrosSite.status == 'DESPUBLICAR' || this.imobiliaria.parametrosSite.status == 'DESPUBLICADO' ? 'Inativo' : 'Novo'}` }}</span>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Latitude" prop="latitude">
                          <el-input v-model="parametrosSite.latitude" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Longitude" prop="longitude">
                          <el-input v-model="parametrosSite.longitude" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Chave Analytics">
                          <el-input v-model="parametrosSite.chaveAnalytics" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="Chave JivoChat">
                          <el-input v-model="parametrosSite.chaveJivoChat" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Server Name" prop="serverName">
                          <el-input v-model="parametrosSite.serverName" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Server Alias">
                          <el-input v-model="parametrosSite.serverAlias" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-document" />
                    Cores
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="8">
                        <el-form-item label="Contact Bar" prop="corPrincipal">
                          <el-input v-model="parametrosSite.corPrincipal" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Hover" prop="corPrincipalHover">
                          <el-input v-model="parametrosSite.corPrincipalHover" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Navbar Logo" prop="corSecundaria">
                          <el-input v-model="parametrosSite.corSecundaria" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="8">
                        <el-form-item label="Background - Main" prop="corFundoClaro">
                          <el-input v-model="parametrosSite.corFundoClaro" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Background - Secondary" prop="corFundoClaroSec">
                          <el-input v-model="parametrosSite.corFundoClaroSec" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Text" prop="corTexto">
                          <el-input v-model="parametrosSite.corTexto" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="8">
                        <el-form-item label="Buttom Disabled" prop="corInativo">
                          <el-input v-model="parametrosSite.corInativo" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-document" />
                    Configurações
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="8">
                        <el-form-item>
                          <el-checkbox v-model="parametrosSite.inverterHeader">Inverter Header</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item>
                          <el-checkbox v-model="parametrosSite.fixarHeader">Fixar Header</el-checkbox>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item>
                          <el-checkbox v-model="parametrosSite.menuBranco">Menu Branco</el-checkbox>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-document" />
                    Informações da Imobiliária
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Quem Somos">
                          <el-input v-model="parametrosSite.quemSomos" type="textarea" rows="4" resize="none" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Missão">
                          <el-input v-model="parametrosSite.missao" type="textarea" rows="4" resize="none" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Visão">
                          <el-input v-model="parametrosSite.visao" type="textarea" rows="4" resize="none" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-document" />
                    Serviços
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Título Um">
                          <el-input v-model="parametrosSite.tituloServicos1" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Texto Um">
                          <el-input v-model="parametrosSite.textoServicos1" type="textarea" rows="4" resize="none" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Título Dois">
                          <el-input v-model="parametrosSite.tituloServicos2" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Texto Dois">
                          <el-input v-model="parametrosSite.textoServicos2" type="textarea" rows="4" resize="none" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Título Três">
                          <el-input v-model="parametrosSite.tituloServicos3" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Texto Três">
                          <el-input v-model="parametrosSite.textoServicos3" type="textarea" rows="4" resize="none" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-document" />
                    Links Úteis
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-table :data="parametrosSite.linksUteis" empty-text="Nenhum Link encontrado">
                      <el-table-column width="50">
                        <template slot-scope="scope">
                          <el-button @click="clickRemoverLinkUtil(scope.$index)" type="text" size="mini" style="padding: 0px; color: #F56C6C">
                            <i class="el-icon-close" />
                          </el-button>
                        </template>
                      </el-table-column>
                      <el-table-column label="Nome" prop="nome" width="200" />
                      <el-table-column label="URL" prop="endereco" />
                    </el-table>

                    <el-button @click="clickAdicionarLinkUtil" type="success" size="mini" style="margin-top: 10px">Adicionar</el-button>
                  </div>
                </el-form>
              </el-tab-pane>

              <el-tab-pane label="Parcerias" name="parcerias" v-if="isVisibleTabParcerias">
                <el-form size="small">
                  <el-row :gutter="10">
                  <el-col :span="11" style="margin-top: 10px">
                  <div style="color: #777; font-weight: bold; font-size: 15px; text-align: center">
                    Imobiliárias Disponíveis
                  </div>
                    <el-table
                      ref="tableImobiliariasDisponiveis"
                      :data="imobiliariasDisponiveis"
                      @selection-change="selecionarImobiliaria"
                      empty-text="Nenhuma Imobiliária disponível"
                      height="600"
                      :row-key="getRowKey"
                    >
                      <el-table-column type="selection" width="30"/>
                      <el-table-column width="50" label="ID" prop="id"/>
                      <el-table-column label="Nome" prop="nome" show-overflow-tooltip/>
                    </el-table>
                  </el-col>
                  <el-col :span="2" style="margin: 270px 0px 0px 0px">
                    <el-row style="margin-left: 32%">
                      <el-button
                        @click="adicionarImobiliariasParceiras"
                        title="Adicionar Imobiliárias"
                        circle
                        type="success"
                        icon="el-icon-plus"
                        size="medium"
                      />
                    </el-row>
                    <el-row style="margin-top: 20px; margin-left: 32%">
                      <el-button
                        @click="removerImobiliariasParceiras"
                        :disabled="desabilitarBotaogravarImobiliarasParceiras"
                        title="Remover Imobiliárias"
                        circle
                        type="warning"
                        icon="el-icon-minus"
                        size="medium"
                      />
                    </el-row>
                  </el-col>
                  <el-col :span="11" style="margin-top: 10px">
                    <div style="color: #777; font-weight: bold; font-size: 15px; text-align: center">
                      Imobiliárias Parceiras
                    </div>
                    <div style="text-align: center">
                    <span style="font-size: 13px; color: #777;">{{ txtQtdImobiliariasParceiras }}</span>
                    </div>
                    <el-table
                      ref="tableImobiliariasParceiras"
                      :data="imobiliaria.imobiliariasParceiras"
                      empty-text="Nenhuma Imobiliária Selecionada"
                      @selection-change="selecionarImobiliariaParceira"
                      height="600"
                    >
                      <el-table-column type="selection" width="30"/>
                      <el-table-column width="60" label="ID" prop="id"/>
                      <el-table-column label="Nome" prop="nome" show-overflow-tooltip/>
                    </el-table>
                  </el-col>  
                  </el-row>
                </el-form>
              </el-tab-pane>
            
            </el-tabs>
          </div>
        </el-main>

        <el-footer height="52px" style="background-color: #D1D1D1; padding: 10px 10px;">
          <el-row style="height: 100%">
            <el-col :span="12" style="height: 100%">
              <el-row type="flex" justify="start" style="padding-top: 0px;">
                <el-button v-if="isVisibleBotaoPublicarSite" @click="clickPublicarSite" size="small" type="primary">Publicar Site</el-button>
                <el-button v-if="isVisibleBotaoDespublicarSite" @click="despublicarSiteHandler" size="small" type="primary">Despublicar Site</el-button>
                <el-button v-if="isVisibleBotaoImportarPreCadastro" @click="clickBotaoImportarPreCadastro" size="small" type="primary">Importar Pré-Cadastro</el-button>
              </el-row>
            </el-col>
            <el-col :span="12" style="height: 100%">
              <el-row type="flex" justify="end" style="padding-top: 0px;">
                <el-button v-if="isVisibleBotaoRemover" @click="clickBotaoRemover" size="small" type="danger">Remover</el-button>
                <el-button v-if="isVisibleBotaoGravar" @click="clickBotaoGravar" size="small" type="success">Gravar</el-button>
                <el-button v-if="isVisibleBotaoGravarParametros" @click="clickBotaoGravarParametros" size="small" type="success">Gravar Parâmetros</el-button>
                <el-button @click="gravarImobiliarasParceiras" v-if="isVisibleBotaoGravarImobiliariasParcerias" size="small" type="success">Gravar ImobiliariasParceiras</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-footer>
        <adicionar-link-util-dialog :visibility="isVisibleDialogAdicionarLinkUtil" @adicionar="adicionarLinkUtil" @close="closeDialogAdicionarLinkUtil" />
        <selecionar-imobiliaria-pre-cadastrada-dialog @selecionar="selecionarImobiliariaPreCadastrada" :visibility="isVisibleDialogSelecionarImobiliariaPreCadastrada" @close="closeDialogSelecionarImobiliariaPreCadastrada" />
        <gravar-usuario-dialog @close="closeDialogGravarUsuario" @gravar="gravarUsuario" :visibility="isVisibleDialogGravarUsuario" :idUsuario="idUsuarioSelecionado" :idImobiliaria="idImobiliariaSelecionada" />
      </el-container>
    </el-col>
  </el-row>
</template>

<script>
import AdicionarLinkUtilDialog from './AdicionarLinkUtilDialog.vue';
import SelecionarImobiliariaPreCadastradaDialog from './SelecionarImobiliariaPreCadastradaDialog';
import GravarUsuarioDialog from './GravarUsuarioDialog';

import { mapActions, mapMutations, mapState } from 'vuex';
import { ESTADOS, HORA_DO_DIA, EMAIL_REGEX } from '../util/constantes';
import { Money } from 'v-money';

export default {
  components: {
    AdicionarLinkUtilDialog,
    SelecionarImobiliariaPreCadastradaDialog,
    GravarUsuarioDialog,
    Money,
  },

  data() {
    return {
      tabSelecionada: 'detalhes',

      imobiliariaPesquisa: {
        nome: '',
        statusContratoSAC: 'ATIVO',
      },

      isVisibleDialogAdicionarLinkUtil: false,
      isVisibleDialogSelecionarImobiliariaPreCadastrada: false,
      isVisibleDialogGravarUsuario: false,

      isLoadingCidades: false,
      isLoadingBairros: false,

      moneyFormat: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      percentFormat: {
        decimal: ',',
        thousands: '.',
        suffix: ' %',
        precision: 2,
        masked: false
      },

      formRules: {
        nome: [{ required: true }],

        razaoSocial: [{ required: true }],

        cnpj: [{ required: true }],

        cpfRepresentante: [{ required: true }],

        telefone: [{ required: true }],

        endereco: [{ required: true }],        

        nomeRepresentante: [{ required: true }],

        estado: [{
          required: true,
          validator: this.validarEstado,
        }],

        cidade: [{
          required: true,
          validator: this.validarCidade,
        }],

        bairro: [{
          required: true,
          validator: this.validarBairro,
        }],

        email: [{
          required: true,
          validator: this.validarEmail
        }],
        emailFinanceiro: [{
          required: true,
          validator: this.validarEmail
        }]
      },

      imobiliariasParceirasSelecionadas: [],
      imobiliariasParceirasRemovidas: [],
      
      idUsuarioSelecionado: 0,

      usuarioPesquisa: {
        nome: '',
      },

      permissoes: [
        { modulo: 'CLIENTES_ALUGUEL' },
        { modulo: 'IMOVEIS_ALUGUEL' },
        { modulo: 'CONTRATOS_ALUGUEL' },
        { modulo: 'RELATORIOS_CLIENTES_ALUGUEL' },
        { modulo: 'RELATORIOS_CONTRATOS_ALUGUEL' },
        { modulo: 'RELATORIOS_IMOVEIS_ALUGUEL' },
        { modulo: 'RELATORIOS_PRETENDENTES_ALUGUEL' },
        { modulo: 'RELATORIOS_FINANCEIROS_ALUGUEL' },
        { modulo: 'CLIENTES_VENDA' },
        { modulo: 'CONTRATOS_VENDA' },
        { modulo: 'IMOVEIS_VENDA' },
        { modulo: 'RELATORIOS_CAPTACOES_VENDA' },
        { modulo: 'RELATORIOS_COMISSOES_VENDA' },
        { modulo: 'RELATORIOS_CLIENTES_VENDA' },
        { modulo: 'RELATORIOS_IMOVEIS_VENDA' },
        { modulo: 'RELATORIOS_PRETENDENTES_VENDA' },
        { modulo: 'CONTAS_RECEBER' },
        { modulo: 'LANCAMENTOS_CONTAS_RECEBER' },
        { modulo: 'CONTAS_PAGAR' },
        { modulo: 'LANCAMENTOS_CONTAS_PAGAR' },
        { modulo: 'CAIXA' },
        { modulo: 'FORNECEDORES' },
        { modulo: 'PLANOS_CONTA' },
        { modulo: 'GRUPOS_CONTA' },
        { modulo: 'PRETENDENTES' },
        { modulo: 'ADMINISTRADORAS' },
        { modulo: 'CONDOMINIOS' },
        { modulo: 'PLACAS' },
        { modulo: 'PERFIS_USUARIOS' },
        { modulo: 'CONTAS_BANCARIAS' },
        { modulo: 'PORTAIS' },
        { modulo: 'LOGS' },
        { modulo: 'VISITA' },
        { modulo: 'SISTEMA' }
      ],

      formParametrosSite: {
        latitude: [{ required: true }],
        longitude: [{ required: true }],
        serverName: [{ required: true }],
        serverAlias: [{ required: true }],
        corPrincipal: [{ required: true, validator: this.validarCoresHex }],
        corPrincipalHover: [{ required: true, validator: this.validarCoresHex }],
        corSecundaria: [{ required: true, validator: this.validarCoresHex }],
        corFundoClaro: [{ required: true, validator: this.validarCoresHex }],
        corFundoClaroSec: [{ required: true, validator: this.validarCoresHex }],
        corTexto: [{ required: true, validator: this.validarCoresHex }],
        corInativo: [{ required: true, validator: this.validarCoresHex }]
      }
    };
  },

  created() {
    this.atualizarImobiliarias();
  },

  computed: {
    ...mapState('loginStore', {
      usuarioLogado: state => state.usuarioLogado,
    }),

    ...mapState('imobiliariasStore', {
      imobiliarias: state => state.imobiliarias,
      qtdImobiliarias: state => state.qtdImobiliarias,
      imobiliaria: state => state.imobiliariaSelecionada,
      parametrosSite: state => state.parametrosSite,
      cidades: state => state.cidades,
      bairros: state => state.bairros,
      imobiliariasDisponiveis: state => state.imobiliariasDisponiveis,
      imobiliariasParceiras: state => state.imobiliariasParceiras
    }),

    idImobiliariaSelecionada() {
      return this.imobiliaria.id;
    },

    estados: () => ESTADOS,
    horaDoDia: () => HORA_DO_DIA,

    textoQtdImobiliarias() {
      switch(this.qtdImobiliarias) {
        case 0:
          return 'Nenhuma Imobiliária Encontrada';
        case 1:
          return '1 Imobiliária Encontrada';
        default:
          return `${this.qtdImobiliarias} Imobiliárias Encontradas`;
      }
    },

    isSelecionadaImobiliaria() {
      return this.imobiliaria.id !== 0;
    },
    isNotSelecionadaImobiliaria() {
      return this.imobiliaria.id === 0;
    },

    textoImobiliariaSelecionada() {
      if(this.isSelecionadaImobiliaria) {
        return this.imobiliaria.nome;
      }

      return 'Nova Imobiliária';
    },

/*   isReadonlyNumeracoes() {
      return this.usuarioLogado.perfil !== 'FINANCEIRO';
    },
    isReadonlyFinanceiro() {
      return this.usuarioLogado.perfil !== 'FINANCEIRO';
    },
    isReadonlyModulos() {
      return this.usuarioLogado.perfil !== 'FINANCEIRO';
    }, */

    isVisibleBotaoGravar() {
      return this.tabSelecionada === 'detalhes'
        || this.tabSelecionada === 'proposta';
    },
    isVisibleBotaoRemover() {
      return this.isSelecionadaImobiliaria
        && this.tabSelecionada === 'detalhes';
    },
    isVisibleBotaoPublicarSite() {
      return this.tabSelecionada === 'parametrosSite';
    },
    isVisibleBotaoDespublicarSite() {
      return this.tabSelecionada === 'parametrosSite' && (this.imobiliaria.parametrosSite.status === 'PUBLICADO' || this.imobiliaria.parametrosSite.status == 'PUBLICAR')
    },
    isVisibleBotaoImportarPreCadastro() {
      return this.tabSelecionada === 'detalhes'
        && this.isNotSelecionadaImobiliaria;
    },
    isVisibleBotaoGravarParametros() {
      return this.tabSelecionada === 'parametrosSite';
    },
    isVisibleTabParametrosSite() {
      return this.isSelecionadaImobiliaria;
    },
    isVisibleTabUsuarios() {
      return this.isSelecionadaImobiliaria;
    },
    isVisibleBotaoGravarImobiliariasParcerias() {
      return this.tabSelecionada === 'parcerias';
    },

    isVisibleTabParcerias() {
      return this.imobiliaria.id !== 0;
    },

    desabilitarBotaogravarImobiliarasParceiras() {
      return this.imobiliaria.imobiliariasParceiras.length === 0;
    },

    txtQtdImobiliariasParceiras() {
      switch (this.imobiliaria.imobiliariasParceiras.length) {
        case 0:
          return 'Nenhuma imobiliária parceira'
        case 1:
          return '1 imobiliária parceira'
        default:
          return `${this.imobiliaria.imobiliariasParceiras.length} imobiliárias parceiras`
      }
    },

    usuarios() {
      return this.imobiliaria.usuarios
        .filter(this.filtrarUsuariosPorNome);
    },

    isSitePublicado() {
      return this.imobiliaria.parametrosSite.status === 'PUBLICADO'
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),

    ...mapMutations('imobiliariasStore', {
      'limparFormImobiliariaMutation': 'limparFormImobiliaria',
      'limparFormParametrosSiteMutation': 'limparFormParametrosSite',
      'preencherFormularioComPreCadastroMutation': 'preencherFormularioComPreCadastro',
      'limparCidadeMutation': 'limparCidade',
      'limparBairroMutation': 'limparBairro',
    }),

    ...mapActions('imobiliariasStore', {
      'listarImobiliariasAction': 'listarImobiliarias',
      'recuperarImobiliariaAction': 'recuperarImobiliaria',
      'recuperarImobiliariaPreCadastradaAction': 'recuperarImobiliariaPreCadastrada',
      'gravarImobiliariaAction': 'gravarImobiliaria',
      'removerImobiliariaAction': 'removerImobiliaria',
      'listarCidadesAction': 'listarCidades',
      'listarBairrosAction': 'listarBairros',
      'recuperarParametrosSiteAction': 'recuperarParametrosSite',
      'gravarParametrosSiteAction': 'gravarParametrosSite',
      'publicarSiteAction': 'publicarSite',
      'listarImobiliariasDisponiveisAction': 'listarImobiliariasDisponiveisParceiros',
      'gravarImobiliariasParceirasAction': 'gravarImobiliariasParceiras',
      'despublicarSiteAction': 'despublicarSite',
      'gravarUsuarioSuporteAction': 'gravarUsuarioSuporte'
    }),

    validarEmail(rule, value, callback) {
      const emailPattern = EMAIL_REGEX;

      if(!value || value.trim() === '') {
        return callback();
      }

      if(emailPattern.test(value)) {
        return callback();
      }

      return callback(new Error());
    },

     validarCoresHex(rule, value, callback) {
      if(value[0] !== '#' || (value.length > 7 || value.length < 7)) {
        return callback(new Error());
      }

      return callback();
    },

    selecionarImobiliaria(imobiliarias) {
      this.imobiliariasParceirasSelecionadas = imobiliarias;
    },

    selecionarImobiliariaParceira(imobiliarias) {
      this.imobiliariasParceirasRemovidas = imobiliarias;
    },

    changeEstado() {
      this.limparCidade();
      this.limparBairro();
    },

    changeCidade() {
      this.limparBairro();
    },

    limparCidade() {
      this.limparCidadeMutation();
    },
    limparBairro() {
      this.limparBairroMutation();
    },

    pressEnterPesquisaNome() {
      this.atualizarImobiliarias();
    },

    clickNovo() {
      this.limparFormImobiliariaMutation();
      this.limparFormParametrosSiteMutation();
      this.goToTab('detalhes');
    },

    clickPesquisar() {
      this.atualizarImobiliarias();
    },

    clickLimpar() {
      this.limparImobiliariaPesquisa();
    },

    clickImobiliaria(imobiliaria) {
      const payload = {
        id: imobiliaria.id,
      };

      this.goToTab('detalhes');
      this.recuperarImobiliaria(payload);
    },

    selecionarImobiliariaPreCadastrada(imobiliaria) {
      this.hideDialogSelecionarImobiliariaPreCadastrada();

      const payload = {
        id: imobiliaria.id,
      };

      this.showLoading();
      this.recuperarImobiliariaPreCadastradaAction(payload)
        .then(resultado => {
          const imobiliaria = resultado.item;
          this.preencherFormularioComPreCadastroMutation(imobiliaria);
        })
        .catch()
        .finally(() => {
          this.hideLoading();
        });
    },

    clickBotaoGravar() {
      this.validarFormularioEGravar();
    },

    clickBotaoRemover() {
      this.confirmarERemoverImobiliaria();
    },

    clickBotaoGravarParametros() {
      this.$refs['formSite'].validate(valid => {
        if(!valid) {
          this.exibirAlerta('Preencha todos os campos obrigatórios')
          return;
        }

        this.gravarParametrosSite();
      })
    },

    gravarParametrosSite() {
      const payload = {
        ...this.parametrosSite,
        id: this.imobiliaria.id
      };

      this.showLoading();
      this.gravarParametrosSiteAction(payload)
        .then(resultado => {
          switch(resultado.status) {
            case 'SUCESSO':
              this.$message.success(resultado.mensagem);
              break;
            case 'ERRO':
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch()
        .finally(() => {
          this.hideLoading();
        });
    },

    confirmarERemoverImobiliaria() {
      this.$confirm('Tem certeza de que deseja Remover a imobiliária?', 'Atenção', {
        type: 'warning',
      }).then(() => {
        this.removerImobiliaria();
      }).catch(() => {});
    },

    removerImobiliaria() {
      this.showLoading();

      const payload = {
        id: this.imobiliaria.id,
      };

      this.removerImobiliariaAction(payload)
        .then(resultado => {
          switch(resultado.status) {
            case 'SUCESSO':
              this.$message.success(resultado.mensagem);
              this.atualizarImobiliarias();
              break;
            case 'ERRO':
              this.$message.error(resultado.mensagem);
          }
        })
        .catch()
        .finally(() => {
          this.hideLoading();
        });
    },

    validarFormularioEGravar() {
      this.$refs.form.validate(isFormValid => {
        if(!isFormValid) {
          this.exibirAlerta('Preencha todos os campos obrigatórios');
          return;
        }

        if(this.validarDataAdmin()) {
          this.exibirAlerta('Data incorreta, formato aceito Ano-Mês-Dia.');
          return;
        } 

        this.gravar();
      });
    },

    gravar() {
      const payload = {
        ...this.imobiliaria,
        estado: {
          id: this.imobiliaria.estado.id,
          nome: this.imobiliaria.estado.nome,
        },
        permissoesAdmin: this.permissoes
      };

      this.showLoading();

      this.gravarImobiliariaAction(payload)
        .then(resultado => {
          switch(resultado.status) {
            case 'SUCESSO':
              this.$message.success(resultado.mensagem);
              if(payload.id === 0) {
                this.trocarFiltroImobiliariaStatus(undefined);
              }
              this.atualizarImobiliarias();
              break;
            case 'ERRO':
              this.$message.error(resultado.mensagem);
              break;
          }
        })
        .catch()
        .finally(() => {
          this.hideLoading();
        });
    },

    trocarFiltroImobiliariaStatus(status) {
      this.imobiliariaPesquisa.statusContratoSAC = status;
    },

    clickBotaoImportarPreCadastro() {
      this.showDialogSelecionarImobiliariaPreCadastrada();
    },

    clickPublicarSite() {
      const payload = {
        id: this.imobiliaria.id,
      };

      this.showLoading();

      this.publicarSiteAction(payload)
        .then(resultado => {
          switch(resultado.status) {
            case 'SUCESSO':
              this.$message.success(resultado.mensagem);
              break;
            case 'ERRO':
              this.$message.error(resultado.mensagem);
          }
        })
        .catch()
        .finally(() => {
          this.hideLoading();
        });
    },

    closeDialogSelecionarImobiliariaPreCadastrada() {
      this.hideDialogSelecionarImobiliariaPreCadastrada();
    },

    showDialogSelecionarImobiliariaPreCadastrada() {
      this.isVisibleDialogSelecionarImobiliariaPreCadastrada = true;
    },
    hideDialogSelecionarImobiliariaPreCadastrada() {
      this.isVisibleDialogSelecionarImobiliariaPreCadastrada = false;
    },

    recuperarImobiliaria(payload) {
      this.showLoading();
      this.recuperarImobiliariaAction(payload)
        .then()
        .finally(() => {
          this.hideLoading();
        });
    },

    atualizarImobiliarias() {
      const payload = { ...this.imobiliariaPesquisa };
      this.showLoading();
      this.listarImobiliariasAction(payload)
        .then()
        .finally(() => {
          this.hideLoading();
        });
    },

    pesquisarCidades(nome) {
      if(this.imobiliaria.estado.id == 0 && nome !== '') {
        this.$message.warning("Selecione o estado");
        return;
      }
      const payload = {
        nome,
        estado: {
          id: this.imobiliaria.estado.id,
        },
      };
      
      this.isLoadingCidades = true;
      this.listarCidadesAction(payload)
      .then()
      .catch(() => {
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
      .finally(() => {
        this.isLoadingCidades = false;
      });
    },

    pesquisarBairros(nome) {
      if(this.imobiliaria.cidade.id == 0 && nome !== '') {
        this.$message.warning("Selecione a cidade");
        return;
      }
      const payload = {
        nome,
        cidade: {
          id: this.imobiliaria.cidade.id,
        },
      };
      
      this.isLoadingBairros = true;
      this.listarBairrosAction(payload)
      .then()
      .catch(() => {
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
      .finally(() => {
        this.isLoadingBairros = false;
      });
    },

    goToTab(newTab) {
      this.tabSelecionada = newTab;
    },

    clickTab(newTab) {
      if(newTab.name === 'parametrosSite') {
        this.clickTabParametrosSite();
      }

      if(newTab.name === 'parcerias') {
        this.listarImobiliariasDisponiveisParcerias();
      }
    },

    clickTabParametrosSite() {
      const payload = {
        id: this.imobiliaria.id,
      };
      this.showLoading();

      this.recuperarParametrosSiteAction(payload)
        .then()
        .finally(() => {
          this.hideLoading();
        });
    },

    adicionarLinkUtil({ nome, endereco }) {
      this.parametrosSite.linksUteis.push({ nome, endereco });
      this.hideDialogAdicionarLinkUtil();
    },

    clickRemoverLinkUtil(index) {
      this.$confirm('Deseja realmente remover este link?', 'Atenção', {
        type: 'warning',
      }).then(() => {
        this.removerLinkUtil(index);
      }).catch(() => {});
    },

    clickAdicionarLinkUtil() {
      this.showDialogAdicionarLinkUtil();
    },

    clickAdicionarUsuario() {
      this.idUsuarioSelecionado = 0;
      this.showDialogGravarUsuario();
    },

    closeDialogGravarUsuario() {
      this.hideDialogGravarUsuario();
    },

    showDialogGravarUsuario() {
      this.isVisibleDialogGravarUsuario = true;
    },
    hideDialogGravarUsuario() {
      this.isVisibleDialogGravarUsuario = false;
    },

    doubleClickUsuario(usuario) {
      this.idUsuarioSelecionado = usuario.id;
      this.showDialogGravarUsuario();
    },

    gravarUsuario() {
      this.hideDialogGravarUsuario();
      const payload = {
        id: this.imobiliaria.id,
      };

      this.recuperarImobiliaria(payload);
    },

    removerLinkUtil(index) {
      this.parametrosSite.linksUteis.splice(index, 1);
    },

    validarEstado(rule, value, callback) {
      if(!value) {
        return callback(new Error());
      }

      if(value.id < 1) {
        return callback(new Error());
      }

      return callback();
    },

    validarCidade(rule, value, callback) {
      if(!value) {
        return callback(new Error());
      }

      if(value.id < 1) {
        return callback(new Error());
      }

      return callback();
    },

    validarBairro(rule, value, callback) {
      if(!value) {
        return callback(new Error());
      }

      if(value.id < 1) {
        return callback(new Error());
      }

      return callback();
    },

    formatarUltimoAcesso(usuario) {
      if(usuario.ultimoAcesso === null) {
        return '';
      }
      return new Date(usuario.ultimoAcesso).toLocaleString();
    },

    filtrarUsuariosPorNome(usuario) {
      const nome = usuario.nome.toLowerCase();
      const search = this.usuarioPesquisa.nome.toLowerCase().trim();

      return nome.includes(search);
    },

    limparImobiliariaPesquisa() {
      this.imobiliariaPesquisa = {
        nome: '',
        statusContratoSAC: 'ATIVO',
      };
    },

    exibirAlerta(mensagem) {
      this.$alert(mensagem, 'Atenção', {
        confirmButtonText: 'OK',
        type: 'warning',
      });
    },

    closeDialogAdicionarLinkUtil() {
      this.hideDialogAdicionarLinkUtil();
    },

    showDialogAdicionarLinkUtil() {
      this.isVisibleDialogAdicionarLinkUtil = true;
    },
    hideDialogAdicionarLinkUtil() {
      this.isVisibleDialogAdicionarLinkUtil = false;
    },

    listarImobiliariasDisponiveisParcerias() {
      const payload = { statusContratoSAC: 'ATIVO' }
      
      this.showLoading();

      this.listarImobiliariasDisponiveisAction(payload)
      .then().finally(() => {
        this.hideLoading();
      })
    },

    getRowKey(imovel) {
      return imovel.id;
    },

    gravarImobiliarasParceiras() {
      this.showLoading();

      this.gravarImobiliariasParceirasAction(this.imobiliaria)
      .then((resposta) => {
        this.$message.success(resposta.mensagem)
      })
      .finally(() => {
        this.hideLoading();
      })
    },

    adicionarImobiliariasParceiras() {
      this.imobiliariasParceirasSelecionadas.forEach(item => {
        let condicao = false;

        this.imobiliaria.imobiliariasParceiras.forEach(imobiliaria => {
          if(item.id === imobiliaria.id) {
            condicao = true;
          }
        })

        if(condicao == false) {
          this.imobiliaria.imobiliariasParceiras.push(item)
        }
      })

      this.$refs['tableImobiliariasDisponiveis'].clearSelection();
    },

    removerImobiliariasParceiras() {
      this.imobiliariasParceirasRemovidas.forEach(item => {
        this.imobiliaria.imobiliariasParceiras = this.imobiliaria.imobiliariasParceiras.filter(imobiliaria => {
          if(imobiliaria.id !== item.id) {
            return imobiliaria;
          }
        })
      })
    },

    despublicarSiteHandler() {
      const payload = {
        id: this.imobiliaria.id
      }

      this.showLoading();

      this.despublicarSiteAction(payload)
      .then()
      .finally(() => {
        this.hideLoading();
      })
    },

    validarDataAdmin() {
      const mes = this.imobiliaria.propostaComercial.data.split('-')[1]
      const dia = this.imobiliaria.propostaComercial.data.split('-')[2]

      if(mes <= 0 || mes > 12) {
        return true;
      }
      if(dia <= 0 || dia > 31) {
        return true;
      }
    },

    gravarUsuarioComoSuporte(usuario) {
      this.showLoading();

      this.gravarUsuarioSuporteAction(usuario)
      .then(resposta => {
        if(resposta.status === "SUCESSO") {
          this.$message.success(resposta.mensagem);
        } else if(resposta.status === 'ERRO') {
          this.$message.error(resposta.mensagem);
        }
      }).catch(() => {
        this.$message.error("Erro ao comunicar-se com o servidor.");
      })

      this.hideLoading();
    }
  },
}
</script>

<style>

</style>